<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <md-card>
      <md-card-content>
        <md-layout md-gutter>
          <md-layout md-flex="10">
            <md-button @click="previousFFView"
              class="md-raised md-primary md-button-color md-theme-default back heght-1px">&laquo; Back</md-button>
          </md-layout>
          <md-layout md-flex="30"></md-layout>
          <md-layout md-flex="40">
            <h2 style="text-align:center">Sales Booking</h2>
          </md-layout>
        </md-layout>

        <hr class="hr-s" />

        <md-layout md-gutter>
          <md-layout md-flex="5"></md-layout>
          <md-layout md-flex="10">
            <label style="margin-top:15px">
              <u>Job Type</u>
            </label>
          </md-layout>

          <md-layout v-for="(segmentNameArray, index) in showSegmentArray" :key="index"
            :md-flex="segmentNameArray.flex">
            <!-- :disabled="ffExoprtDetail.allModuleId!=''?true:false" -->
            <md-checkbox v-model="ffExoprtDetail.jobType[index]" class="md-primary" :md-value="segmentNameArray.value"
              :name="'jobType'+(index+1)" :id="'jobType'+(index+1)"
              :disabled="ffExoprtDetail.allModuleId!=''?true:false"
              @change="jobTypeSelect(segmentNameArray.value,index)">{{segmentNameArray.show}}</md-checkbox>
          </md-layout>
        </md-layout>
        <hr class="hr-border" />

        <div v-if="newJobType.length>0">
          <md-layout md-gutter class="labelMargtop">
            <md-layout md-flex="5"></md-layout>
            <md-layout md-flex="25">
              <label for="transportType">Export / Import</label>
              <model-list-select :list="transportTypeList" v-model="ffExoprtDetail.transportType"
                option-value="transportTypeVal" option-text="transportTypeText"
                placeholder="Select Type"></model-list-select>
              <span class="error" v-if="!ffExoprtDetail.transportType">{{transportTypeError}}</span>
            </md-layout>
          </md-layout>
          <div v-if="newJobType.indexOf('TPT')>=0">
            <hr class="hr-bodr" />
            <md-layout md-gutter class="labelMargtop">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <label for="clientId">Client Name (Transportation)</label>

                <model-list-select :list="clientList" id="clientNamenew" v-model="ffExoprtDetail.clientId"
                  option-value="clientId" option-text="clientName"
                  placeholder="Select Existing Client Name"></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.clientId">{{clientIdError}}</span>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="labelMargtop">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <label for="AutoPickupLocation">Pickup Location (Transportation)</label>

                <model-list-select @input="getLocationList($event,'All','getAlllocationListData')"
                  @searchchange="getLocationList($event,'All','getAlllocationListData')" :list="allLocationList"
                  v-model="ffExoprtDetail.pickupLocationId" option-value="pickupId" option-text="pickupLocation"
                  placeholder="Select Pickup Location"></model-list-select>

                <span class="error" v-if="!ffExoprtDetail.pickupLocationId">{{pickupLocationIdError}}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <label for="AutoStuffingLocation">Factory Location (Transportation)1</label>

                <model-list-select :list="tempfactoryDetail" v-model="ffExoprtDetail.stuffingLocationId"
                  option-value="location" option-text="factoryTitle"
                  :isDisabled="ffExoprtDetail.clientId==''?true:false"
                  :placeholder="factoryDetail.length>0?'Select Factory Location':'No Factory'"></model-list-select>

                <span class="error" v-if="!ffExoprtDetail.stuffingLocationId">{{stuffingLocationIdError}}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <label for="AutoHandoverLocation">Handover Location (Transportation)</label>

                <model-list-select @input="getLocationList($event,'All','getAlllocationHandover')"
                  @searchchange="getLocationList($event,'All','getAlllocationHandover')" :list="getAlllocationHandover"
                  v-model="ffExoprtDetail.handoverLocationId" option-value="pickupId" option-text="pickupLocation"
                  placeholder="Select Handover Location"></model-list-select>

                <span class="error" v-if="!ffExoprtDetail.handoverLocationId">{{handoverLocationIdError}}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="labelMargtop">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25" class="labelMargtop">
                <label for="containerTypeId">Container Type/Size (Transportation)</label>
                <model-list-select :list="ContainerTypeList" v-model="ffExoprtDetail.transContainerTypeId"
                  option-value="containerTypeId" option-text="containerType"
                  placeholder="Select Container Type/Size"></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.transContainerTypeId">{{transContainerTypeIdError}}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label for="noOfContainer">No. of Containers</label>

                  <b-form-input :formatter="capitalizeAll" id="noOfContainer" name="noOfContainer" type="number"
                    v-model="ffExoprtDetail.noOfContainer"></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="labelMargtop"
              v-if="(newJobType.indexOf('FF')>=0 && newJobType.indexOf('TPT')>=0)">
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="35">
                <label for="ccType">TPT Type</label>
                <model-list-select :list="cctypeList" v-model="ffExoprtDetail.tptType" option-value="ccTypeVal"
                  option-text="ccTypeTxt" placeholder="Select TPT Type"></model-list-select>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="50" v-if="ffExoprtDetail.tptType=='2'">
                <md-layout md-flex="100">
                  <label>Transporter Name</label>
                  <b-form-input :formatter="capitalizeAll" id="transporterName" name="transporterName"
                    v-model="ffExoprtDetail.transporterName"></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
          </div>

          <div v-if="newJobType.indexOf('FF')>=0 || newJobType.indexOf('CC')>=0">
            <hr class="hr-bodr" />
            <md-layout md-gutter class="labelMargtop">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="35">
                <label for="containerInfo">FF Activity Type</label>
                <model-list-select :list="containerInfoList" v-model="ffExoprtDetail.containerInfo"
                  option-value="containerInfoVal" option-text="containerInfoText"
                  placeholder="Select Activity Type"></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.containerInfo">{{containerInfoError}}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="35">
                <label for="shipmentType">Shipping Type</label>
                <model-list-select isDisabled :list="shipmentTypeList" v-model="ffExoprtDetail.shipmentType"
                  option-value="shipmentTypeVal" option-text="shipmentTypeText"
                  placeholder="Select Shipment Type"></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.shipmentType">{{shipmentTypeError}}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="labelMargtop">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="35">
                <label for="clientId">Importer Name (Freight)</label>

                <model-list-select :list="clientList" id="clientNamenew" v-model="ffExoprtDetail.importerClientId"
                  option-value="clientId" option-text="clientName"
                  placeholder="Select Importer Name"></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.importerClientId">{{importerClientIdError}}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="35">
                <label for="clientId">Exporter Name (Freight)</label>

                <model-list-select :list="clientList" id="clientNamenew" v-model="ffExoprtDetail.exporterClientId"
                  option-value="clientId" option-text="clientName"
                  placeholder="Select Exporter Name"></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.exporterClientId">{{exporterClientIdError}}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="35">
                <label for="stuffingType">Stuffing Type</label>
                <model-list-select :list="stuffingTypeList" v-model="ffExoprtDetail.stuffingType"
                  option-value="stuffingTypeVal" option-text="stuffingTypeText" placeholder="Select Stuffing Type"
                  :isDisabled="ffExoprtDetail.containerInfo!='fcl'?true:false"></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.stuffingType">{{stuffingTypeError}}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="35">
                <label for="shippingId">Shipping Line Name</label>
                <model-list-select :list="shippingList" v-model="ffExoprtDetail.shippingId" option-value="shippingId"
                  option-text="shippingLine" placeholder="Select Shipping Line"></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.shippingId">{{shippingIdError}}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="labelMargtop">
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="35">
                <label for="PORlocationId">Place of Receipt (Freight)</label>
                <model-list-select @input="getLocationList($event,'Icd,Sea_Port','IcdPOrtList')"
                  @searchchange="getLocationList($event,'Icd,Sea_Port','IcdPOrtList')" :list="IcdPOrtList"
                  v-model="ffExoprtDetail.PORlocationId" option-value="pickupId" option-text="pickupLocation"
                  placeholder="Select Place of Receipt"></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.PORlocationId">{{PORlocationIdError}}</span>
              </md-layout>

              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="35">
                <label for="LPlocationId">Load Port Name (Freight)</label>
                <model-list-select @input="getLocationList($event,'Sea_Port','PortLoadList')"
                  @searchchange="getLocationList($event,'Sea_Port','PortLoadList')" :list="PortLoadList"
                  v-model="ffExoprtDetail.LPlocationId" option-value="pickupId" option-text="pickupLocation"
                  placeholder="Select Load Port Name" :isDisabled="ffExoprtDetail.portType!='Icd'?true:false"
                  :isError="ffExoprtDetail.portType!='Icd'?true:false"></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.LPlocationId">{{LPlocationIdError}}</span>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="labelMargtop">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="35">
                <label for="PODLocationId">Port of Discharge (Freight)</label>
                <model-list-select @input="getLocationList($event,'Sea_Port','getPortDischargeList')"
                  @searchchange="getLocationList($event,'Sea_Port','getPortDischargeList')" :list="PortDischargeList"
                  v-model="ffExoprtDetail.PODLocationId" option-value="pickupId" option-text="pickupLocation"
                  placeholder="Select POD"></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.PODLocationId">{{PODLocationIdError}}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="35">
                <label for="finalPlaceLocationId">Final Place of Delivery (Freight)</label>
                <model-list-select @input="getLocationList($event,'All','finalAllPlaceData')"
                  @searchchange="getLocationList($event,'All','finalAllPlaceData')" :list="finalAllPlaceData"
                  v-model="ffExoprtDetail.finalPlaceLocationId" option-value="pickupId" option-text="pickupLocation"
                  placeholder="Select FPOD"></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.finalPlaceLocationId">{{finalPlaceLocationIdError}}</span>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="labelMargtop">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="35">
                <label for="deliveryMode">Destination Delivery Mode</label>
                <model-list-select :list="deliveryModeList" v-model="ffExoprtDetail.deliveryMode"
                  option-value="deliveryModeVal" option-text="deliveryModeText"
                  placeholder="Select Delivery Mode"></model-list-select>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="35">
                <label for="deliveryTerms">Delivery Terms(INCOTERMS)</label>
                <model-list-select :list="deliveryTermsList" v-model="ffExoprtDetail.deliveryTerms"
                  option-value="deliveryTermsVal" option-text="deliveryTermsText"
                  placeholder="Select Delivery Terms"></model-list-select>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="labelMargtop"
              v-if="(newJobType.indexOf('FF')>=0 && newJobType.indexOf('CC')>=0) ">
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="35">
                <label for="ccType">CC Type</label>
                <model-list-select :list="cctypeList" v-model="ffExoprtDetail.ccType" option-value="ccTypeVal"
                  option-text="ccTypeTxt" placeholder="Select CC Type"></model-list-select>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="50" v-if="ffExoprtDetail.ccType=='2'">
                <md-layout md-flex="100">
                  <label>CHA Name</label>
                  <b-form-input :formatter="capitalizeAll" id="ccCha" name="ccCha"
                    v-model="ffExoprtDetail.ccCha"></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="90">
                <md-layout md-flex="100">
                  <label>Remarks</label>
                  <b-form-textarea :formatter="capitalizeAll" id="remark" name="remark"
                    v-model="ffExoprtDetail.remark"></b-form-textarea>
                </md-layout>
              </md-layout>
            </md-layout>
            <hr class="hr-border" />
          </div>

          <div v-if="newJobType.indexOf('CC')>=0 || newJobType.indexOf('FF')>=0">
            <md-layout md-gutter class="labelMargtop">
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="25">
                <label for="autoCommodity">Commodity</label>
                <model-list-select :list="commodityList" v-model="CommodityAll" option-value="commodityId"
                  option-text="itemDescription" placeholder="Select Commodity"></model-list-select>
                <span class="error" v-if="!ffExoprtDetail.commodityType">{{commodityTypeError}}</span>
              </md-layout>
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label for="commodityType">Commodity Type</label>

                  <b-form-input :formatter="capitalizeAll" id="commodityType" name="commodityType" disabled
                    v-model="ffExoprtDetail.commodityType"></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr">
              <md-layout md-flex="5"></md-layout>

              <md-layout md-flex="90">
                <md-layout md-flex="100">
                  <label for="itemDescription">Item Description</label>

                  <b-form-textarea :formatter="capitalizeAll" id="itemDescription" name="itemDescription" disabled
                    v-model="ffExoprtDetail.itemDescription"></b-form-textarea>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr" v-if="ffExoprtDetail.commodityType=='Hazardous'">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>IMDG Class</label>
                  <b-form-input :formatter="capitalizeAll" id="IMDGClass" name="IMDGClass"
                    v-model="ffExoprtDetail.IMDGClass"></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>UN Number</label>
                  <b-form-input :formatter="capitalizeAll" id="UNNumber" name="UNNumber"
                    v-model="ffExoprtDetail.UNNumber"></b-form-input>
                </md-layout>
              </md-layout>
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>Packing Code</label>
                  <b-form-input :formatter="capitalizeAll" id="packingCode" name="packingCode"
                    v-model="ffExoprtDetail.packingCode"></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
            <md-layout md-gutter class="gutr" v-if="ffExoprtDetail.commodityType=='Reefer'">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="25">
                <md-layout md-flex="100">
                  <label>Temperature Req(Degree Celsius)</label>
                  <b-form-input :formatter="capitalizeAll" id="temperatureRequired" name="temperatureRequired"
                    v-model="ffExoprtDetail.temperatureRequired"></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>

            <md-layout md-gutter class="gutr" v-if="ffExoprtDetail.commodityType=='Others'">
              <md-layout md-flex="5"></md-layout>
              <md-layout md-flex="90">
                <md-layout md-flex="100">
                  <label>Specific Detail if any..!</label>
                  <b-form-input :formatter="capitalizeAll" id="otherComodity" name="otherComodity"
                    v-model="ffExoprtDetail.otherComodity"></b-form-input>
                </md-layout>
              </md-layout>
            </md-layout>
          </div>
          <hr class="hr-border" />
          <md-layout md-gutter class="mrgtop-button" v-if="allModuleIdNew=='' || allModuleIdNew==null">
            <md-layout md-flex="45"></md-layout>
            <md-button class="md-raised md-primary md-button-color heght-1px mrgtop-2per" id="addButtonLoader"
              @click="addFFExport">Submit</md-button>
            <md-spinner md-indeterminate id="loader" style="display:none"></md-spinner>
          </md-layout>
        </div>
      </md-card-content>
    </md-card>

    <!-- <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop22"
      @close="onClose22"
    ></md-dialog-alert>-->
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" @close="onCloseAddFF"
      ref="addPop"></md-dialog-alert>
  </div>
</template>


<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat} from "../../helper/filters";
import {
  globalPermissionStatus,
  GlobalGetLocation
} from "../../helper/collection";

export default {
  beforeMount() {
    if (globalPermissionStatus("Enquiry & Pricing")) {
      this.$store.dispatch("setCurrentRoute", "/allModuleForm/allModuleForm");
      this.getServicesData();
      this.getData();
    } else {
      this.$router.push({
        path: "/dashboard"
      });
    }
  },
  watch: {
    CommodityAll: {
      handler: function(newVal, oldVal) {
        this.CommodityCallback(newVal);
      },
      deep: true
    },
    ffExoprtDetail: {
      handler: function(newVal, oldVal) {
        if (
          this.ffExoprtDetail.PORlocationId != "" &&
          this.ffExoprtDetail.allModuleId == ""
        ) {
          let array = this.IcdPOrtList.filter(x => {
            return x.pickupId == newVal.PORlocationId;
          })[0];
          console.log(array, "vdfds");

          this.ffExoprtDetail.portType = array.locationType;
          if (array.locationType != "Icd") {
            this.PortLoadList = this.IcdPOrtList;
            this.ffExoprtDetail.LPlocationId = newVal.PORlocationId;
          }

          this.deliveryTermsName[1].deliveryTermsText =
            "FOB_POR_ " + array.mainLocation;
        }

        if (
          newVal.LPlocationId != "" &&
          this.ffExoprtDetail.allModuleId == ""
        ) {
          let array1 = this.PortLoadList.filter(x => {
            return x.pickupId == newVal.LPlocationId;
          })[0];
          this.deliveryTermsName[2].deliveryTermsText =
            "FOB_LoadPort_ " + array1.pickupLocation;
        }

        if (
          this.ffExoprtDetail.shipmentType == "Sea_Shipment" &&
          this.ffExoprtDetail.allModuleId == ""
        ) {
          //   let array1 = this.getAlllocationListData.filter(x => {
          //     return x.locationType == "Sea_Port";
          //   });
          //   let array2 = this.getAlllocationListData.filter(x => {
          //     return x.locationType == "Sea_Port" || x.locationType == "Icd";
          //   });
          //   this.IcdPOrtList = array2;
          //   this.getPortDischargeList = array1;
          // }
          if (
            newVal.containerInfo != "fcl" &&
            this.ffExoprtDetail.allModuleId == ""
          ) {
            this.ffExoprtDetail.stuffingType = "warehouseStuffing";
          }
        }
        if (this.ffExoprtDetail.clientId != "") {
          this.factoryDetail = this.tempfactoryDetail.filter(x => {
            return x.clientId == this.ffExoprtDetail.clientId;
          });
        }
      },
      deep: true
    }
  },
  data() {
    return {
      isLoading: false,
      factoryDetail: [],
      tempfactoryDetail: [],
      opnTPT: false,
      transportTypeName: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export"
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import"
        }
        // {
        //   transportTypeVal: "Empty_Moment",
        //   transportTypeText: "Empty Moment"
        // }
      ],
      stuffingTypeName: [
        {
          stuffingTypeVal: "factoryStuffing",
          stuffingTypeText: "Factory Stuffing"
        },
        {
          stuffingTypeVal: "warehouseStuffing",
          stuffingTypeText: "Warehouse Stuffing"
        }
      ],

      containerInfoName: [
        {
          containerInfoVal: "fcl",
          containerInfoText: "FCL"
        },
        {
          containerInfoVal: "lcl",
          containerInfoText: "LCL"
        },
        {
          containerInfoVal: "FclConsolidation",
          containerInfoText: "FCL Consolidation"
        },
        {
          containerInfoVal: "LclConsolidation",
          containerInfoText: "LCL Consolidation"
        }
      ],
      cctypeList: [
        {
          ccTypeVal: "1",
          ccTypeTxt: "Pridel"
        },
        {
          ccTypeVal: "2",
          ccTypeTxt: "Outsourced"
        },
        {
          ccTypeVal: "3",
          ccTypeTxt: "Not Applicable"
        }
      ],
      deliveryModeName: [
        {
          deliveryModeVal: "CY_CY",
          deliveryModeText: "CY / CY"
        },
        {
          deliveryModeVal: "CY_RAMP",
          deliveryModeText: "CY / RAMP"
        },
        {
          deliveryModeVal: "CY_StoreDoor",
          deliveryModeText: "CY / Store Door"
        }
      ],

      deliveryTermsName: [
        {
          deliveryTermsVal: "ExWorks",
          deliveryTermsText: "Ex-Works"
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP"
        },
        {
          deliveryTermsVal: "DAP",
          deliveryTermsText: "DAP"
        },
        {
          deliveryTermsVal: "DDP",
          deliveryTermsText: "DDP"
        },
        {
          deliveryTermsVal: "FOB_POR",
          deliveryTermsText: "FOB_POR_"
        },
        {
          deliveryTermsVal: "FOB_LoadPort",
          deliveryTermsText: "FOB_LoadPort_"
        },
        {
          deliveryTermsVal: "FCA",
          deliveryTermsText: "FCA"
        },
        {
          deliveryTermsVal: "FAS",
          deliveryTermsText: "DDP"
        },
        {
          deliveryTermsVal: "CFR",
          deliveryTermsText: "CFR"
        },
        {
          deliveryTermsVal: "CIF",
          deliveryTermsText: "CIF"
        },
        {
          deliveryTermsVal: "CIP",
          deliveryTermsText: "CIP"
        },
        {
          deliveryTermsVal: "CPT",
          deliveryTermsText: "CPT"
        },
        {
          deliveryTermsVal: "DAF",
          deliveryTermsText: "DAF"
        },
        {
          deliveryTermsVal: "DES",
          deliveryTermsText: "DES"
        },
        {
          deliveryTermsVal: "DEQ",
          deliveryTermsText: "DEQ"
        }
      ],

      showAdd: false,

      alert: {
        content:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Data Updated Succesfully"
            : "Added Succesfully",
        ok: "ok"
      },
      allAgentColoader: [],
      CommodityAll: {},
      autoClientName: {},
      ffExoprtDetail: {
        ccType: "",
        tptType: "",
        ccCha: "",
        transporterName: "",
        allModuleId: "",
        transContainerTypeId: "",
        transContainerType: "",
        pickupLocationId: "",
        stuffingLocationId: "",
        handoverLocationId: "",
        containerId: "",
        clientId: "",
        shippingId: "",
        shipmentType: "Sea_Shipment",
        transportType: "",
        stuffingType: "",
        containerInfo: "",
        PORlocationId: "",
        LPlocationId: "",
        PODLocationId: "",
        finalPlaceLocationId: "",
        deliveryMode: "",
        deliveryTerms: "",
        exporterClientId: "",
        importerClientId: "",
        commodityId: "",
        IMDGClass: "",
        commodityType: "",
        itemDescription: "",
        UNNumber: "",
        packingCode: "",
        temperatureRequired: "",
        otherComodity: "",
        remark: "",
        portType: "",
        jobType: [],
        noOfContainer: ""
      },
      transportTypeError: "",
      clientIdError: "",
      pickupLocationIdError: "",
      stuffingLocationIdError: "",
      handoverLocationIdError: "",
      transContainerTypeIdError: "",
      containerInfoError: "",
      shipmentTypeError: "",
      importerClientIdError: "",
      commodityTypeError: "",
      exporterClientIdError: "",
      stuffingTypeError: "",
      shippingIdError: "",
      PORlocationIdError: "",
      LPlocationIdError: "",
      PODLocationIdError: "",
      finalPlaceLocationIdError: "",

      deleteId: "",

      containerModal: {
        containerType: "",
        noOfContainer: "",
        containerTypeId: ""
      },
      shippingIdError: "",
      totalContainer: "",
      noOfContainerError: "",
      containerTypeIdError: "",

      fobReceiptName: "",
      fobLoadPortName: "",
      commodityArray: [],
      getPortData: ["Agra"],

      error: {
        clientNameError: "",
        toPortError: "",
        fromPortError: "",
        transhipmentNameError: "",
        addOneTranError: ""
      },
      getCLientData: ["gfdg"],
      showSegmentArray: [],
      showOtherServiceArray: [],
      showAdditionalMoreTaskArray: [],
      driverNameDetail: ["iji"],
      editVar: {
        Inputval:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "Add",
        FormVal:
          this.$sessionsStorage.get("editExportFCLId") != "" &&
          this.$sessionsStorage.get("editExportFCLId") != undefined
            ? "Update"
            : "New"
      },
      errorAtleastOne: "",

      ffExportError: [
        "Please Select Client Name",
        "Please Select Place of Receipt",
        "Please Select Load  Port Name",
        "Please Select Port  of Discharge",
        "Please Select final Delievery",
        "Please Select Commidity",
        "Please Select Stuffing type",
        "Please Select Delivery  Terms",
        "Please Select Delivery Mode",
        "Please Select Exporter Name",
        "Please Select Importer Name",
        "Please Select Shipment type",
        "Please Select FF Activity",
        "Please Select Container type",
        "Please Select Handover Location",
        "Please Select Stuffing Location",
        "Please Select Pickup Location",
        "Please Select Transport Type",
        "Please Select Shipping Line"
      ],
      ffExporterrorList: {
        clientId: "",
        PORlocationId: "",
        LPlocationId: "",
        PODLocationId: "",
        finalPlaceLocationId: "",
        commodityId: "",
        stuffingType: "",
        deliveryTerms: "",

        deliveryMode: "",
        exporterClientId: "",
        importerClientId: "",
        shipmentType: "",
        containerInfo: "",
        transContainerTypeId: "",
        handoverLocationId: "",
        stuffingLocationId: "",
        pickupLocationId: "",
        transportType: "",
        shippingId: ""
      },

      ContainerError: [
        "Please Select Container",
        "Please Enter No of Container"
      ],
      containererrorList: {
        containerTypeId: "",
        noOfContainer: ""
      },
      getPortDischargeList: [],
      PortLoadList: [],
      shipmentTypeList: [
        {
          shipmentTypeVal: "Sea_Shipment",
          shipmentTypeText: "Sea"
        }
        // {
        //   shipmentTypeVal: "Air_Shipment",
        //   shipmentTypeText: "Air"
        // }
      ],
      allModuleIdNew:
        this.$sessionsStorage.get("editallModuleId") != "" ||
        this.$sessionsStorage.get("editallModuleId") != undefined
          ? this.$sessionsStorage.get("editallModuleId")
          : "",
      jobTypeSelectVal: false,
      otherServicesVal: false,

      getShippingLineData: ["zim"],
      getCommodityData: ["zim"],
      getContainerTypeData: ["zim"],
      getlocationListData: ["agra"],
      getAlllocationListData: [],
      getAlllocationHandover: [],
      IcdPOrtList: [],

      finalAllPlaceData: [],
      validate: true,
      clientNameError: "",
      addDriverError1: "",
      addTruckError4: "",
      ExecutionDisable: "",
      newJobType: []
    };
  },

  mounted() {},
  beforeDestroy() {
    this.$sessionsStorage.set("editallModuleId", "");
  },
  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    // Loading
    CustomLoader,
  },
  computed: {
    clientList() {
      return this.getCLientData;
    },
    ContainerTypeList() {
      return this.getContainerTypeData;
    },
    shippingList() {
      return this.getShippingLineData;
    },
    locationList() {
      return this.getlocationListData;
    },
    IcdPOrtListNew() {
      return this.IcdPOrtList;
    },

    PortDischargeList() {
      return this.getPortDischargeList;
    },
    allLocationList() {
      return this.getAlllocationListData;
    },
    PortList() {
      return this.getPortData;
    },
    viewDocument() {
      return this.ffExoprtDetail.uploadDriverDoc.split(",");
    },
    vehicleMasterList() {
      return this.driverNameDetail;
    },
    commodityList() {
      return this.getCommodityData;
    },

    transportTypeList() {
      return this.transportTypeName;
    },

    stuffingTypeList() {
      return this.stuffingTypeName;
    },

    containerInfoList() {
      return this.containerInfoName;
    },

    deliveryModeList() {
      return this.deliveryModeName;
    },

    deliveryTermsList() {
      return this.deliveryTermsName;
    },

    pdaDetailList() {
      return this.pdaDetailsName;
    },
    oceanFreightTermsList() {
      return this.oceanFreightTermsName;
    },
    prepaidDetailsList() {
      return this.prepaidDetailsName;
    },
    collectDetailsList() {
      return this.collectDetailsName;
    },

    agentNameList() {
      return this.getagentName;
    },
    getColoaderNameList() {
      return this.getColoaderName;
    }
  },
  methods: {
    getLocationList(event, type, vmodelArray) {
      let vehicle_drive = {
        value: event,
        type: type
      };
      let self = this;

      if (event != "") {
        GlobalGetLocation(vehicle_drive, function(error, result) {
          if (error) {
          } else if (result) {
            if (result.length > 0) {
              self[vmodelArray] = result;
            }
          }
        });
      }
    },
    doLoading() {
      this.isLoading = true;
    },

    doLoadingClose() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    methodsHere() {},
    showMultiple() {
      this.ffExoprtDetail.additionalMoreTask.map(x => {
        if (x.value == "OthersSpecify") {
          this.showAdd = true;
          return false;
        } else {
          this.showAdd = false;
        }
      });
    },

    getPortId1(item) {
      this.ffExoprtDetail.toportId = item.portId;
    },
    getPortId2(item) {
      this.ffExoprtDetail.fromportId = item.portId;
    },
    getPortId3(item) {
      this.transhipment.tentportId = item.portId;
    },

    CommodityCallback(item) {
      this.ffExoprtDetail.commodityId = item.commodityId;
      this.ffExoprtDetail.commodityType = item.commodityType;
      this.ffExoprtDetail.itemDescription = item.itemDescription;
    },
    otherServiceNameArraySelect(value, index) {
      if (value == "None") {
        if (this.otherServicesVal == false) {
          this.ffExoprtDetail.otherServices = Array(
            this.showOtherServiceArray.length
          ).fill(false);
          this.otherServicesVal = true;
        } else {
          this.ffExoprtDetail.otherServices = Array(
            this.showOtherServiceArray.length
          ).fill(false);
          this.otherServicesVal = false;
        }
        this.getServicesData();
      }
    },

    jobTypeSelect(value, index) {
      // if (value == "All") {
      //   if (this.jobTypeSelectVal == false) {
      //     this.ffExoprtDetail.jobType = Array(
      //       this.showSegmentArray.length
      //     ).fill(true);
      //     this.jobTypeSelectVal = true;
      //     this.newJobType = ["TPT", "FF", "CC"];
      //   } else {
      //     this.ffExoprtDetail.jobType = Array(
      //       this.showSegmentArray.length
      //     ).fill(false);
      //     this.jobTypeSelectVal = false;
      //     this.newJobType = [];
      //   }
      // } else {
      let i = this.newJobType.indexOf(value);

      if (i >= 0) {
        this.newJobType.splice(i, 1);
      } else {
        this.newJobType.push(value);
      }
      // }
      console.log(this.newJobType, "fsdfsd");

      //  if (this.ffExoprtDetail.jobType.length == 0) {
      //   this.ffExoprtDetail.jobType.push(value);
      //   console.log("a")
      // } else {
      //      console.log("b")
      //   let i = this.ffExoprtDetail.jobType.indexOf(value);
      //   if (i >= 0) {
      //        console.log("c")
      //     this.ffExoprtDetail.jobType.splice(i, 1);
      //   } else {
      //        console.log("d")
      //     this.ffExoprtDetail.jobType.push(value);
      //   }
      // }
    },
    JqueryFun() {
      return $(function() {
        return $("#FreghtContaner").DataTable();
      });
    },
    clientFilter(list, query) {
      return this.getCLientData.filter(x => {
        return x.clientName.toLowerCase().includes(query.toLowerCase());
      });
    },
    PortFilter(list, query) {
      return this.getPortData.filter(x => {
        return x.portName.toLowerCase().includes(query.toLowerCase());
      });
    },
    validateFFExport() {
      let validate_new = true;

      if (
        this.ffExoprtDetail.clientId == "" &&
        this.newJobType.indexOf("TPT") >= 0
      ) {
        $("#clientId").focus();
        this.clientIdError = "Select client name";
        validate_new = false;
      }

      if (this.ffExoprtDetail.transportType == "") {
        $("#transportType").focus();
        this.transportTypeError = "Select Transport Type";
        validate_new = false;
      }

      if (
        this.ffExoprtDetail.pickupLocationId == "" &&
        this.newJobType.indexOf("TPT") >= 0
      ) {
        $("#pickupLocationId").focus();
        this.pickupLocationIdError = "Select Pickup Location";
        validate_new = false;
      }
      if (
        this.ffExoprtDetail.stuffingLocationId == "" &&
        this.newJobType.indexOf("TPT") >= 0
      ) {
        $("#stuffingLocationId").focus();
        this.stuffingLocationIdError = "Select Factory  Location";
        validate_new = false;
      }

      if (
        this.ffExoprtDetail.handoverLocationId == "" &&
        this.newJobType.indexOf("TPT") >= 0
      ) {
        $("#handoverLocationId").focus();
        this.handoverLocationIdError = "Select Handover Location";
        validate_new = false;
      }
      if (
        this.ffExoprtDetail.transContainerTypeId == "" &&
        this.newJobType.indexOf("TPT") >= 0
      ) {
        $("#transContainerTypeId").focus();
        this.transContainerTypeIdError = "Select Container Type";
        validate_new = false;
      }

      if (
        this.newJobType.indexOf("FF") >= 0 ||
        this.newJobType.indexOf("CC") >= 0
      ) {
        if (this.ffExoprtDetail.containerInfo == "") {
          $("#containerInfo").focus();
          this.containerInfoError = "Select FF Activity";
          validate_new = false;
        }

        if (this.ffExoprtDetail.shipmentType == "") {
          $("#shipmentType").focus();
          this.shipmentTypeError = "Select Shipping Type";
          validate_new = false;
        }

        if (this.ffExoprtDetail.importerClientId == "") {
          $("#importerClientId").focus();
          this.importerClientIdError = "Select Importer Name";
          validate_new = false;
        }
        if (this.ffExoprtDetail.commodityType == "") {
          $("#commodityType").focus();
          this.commodityTypeError = "Select Commodity";
          validate_new = false;
        }

        if (this.ffExoprtDetail.exporterClientId == "") {
          $("#exporterClientId").focus();
          this.exporterClientIdError = "Select Exporter Name";
          validate_new = false;
        }

        if (this.ffExoprtDetail.stuffingType == "") {
          $("#stuffingType").focus();
          this.stuffingTypeError = "Select Stuffing Type";
          validate_new = false;
        }
        if (this.ffExoprtDetail.shippingId == "") {
          $("#shippingId").focus();
          this.shippingIdError = "Select Shipping Line";
          validate_new = false;
        }
        if (this.ffExoprtDetail.PORlocationId == "") {
          $("#PORlocationId").focus();
          this.PORlocationIdError = "Select Place Of Receipt";
          validate_new = false;
        }
        if (this.ffExoprtDetail.LPlocationId == "") {
          $("#LPlocationId").focus();
          this.LPlocationIdError = "Select Load Port";
          validate_new = false;
        }
        if (this.ffExoprtDetail.PODLocationId == "") {
          $("#PODLocationId").focus();
          this.PODLocationIdError = "Select Port Of Discharge";
          validate_new = false;
        }
        if (this.ffExoprtDetail.finalPlaceLocationId == "") {
          $("#finalPlaceLocationId").focus();
          this.finalPlaceLocationIdError = "Select Final Place Of Delivery";
          validate_new = false;
        }
      }

      if (validate_new != true) {
        if (this.commodityArray.length > 0) {
          window.scroll(0, 40);
        }
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    addFFExport() {
      this.validateFFExport();

      if (this.validate != false) {
        let newVal = [];

        this.showSegmentArray.map((x, index) => {
          if (this.ffExoprtDetail.jobType[index] == true) {
            newVal.push(x.value);
          }
        });

        this.ffExoprtDetail["jobType"] = newVal;
        $("#addButtonLoader").css("display", "none");
        $("#loader").css("display", "block");

        let options = {
          method: "POST",
          url: `${URL_BASE}/Enquiry/addALLModules.php`,
          data: JSON.stringify(this.ffExoprtDetail),
          crossDomain: true,

          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId")
          }
        };

        axios(options)
          .then(result => {
            const { statusText, status, data } = result;
            if ( status == 200 && data) {
              $("#loader").css("display", "none");
              $("#addButtonLoader").css("display", "block");
              this.alert.content = "Data Added Successfully";
              this.$refs["addPop"].open();
            }
          })
          .catch(error => {});
      }
    },
    onCloseAddFF() {
      this.$router.push({
        path: "/viewAllModuleDetails/viewAllModuleDetails"
      });
    },

    validateFFContainer() {
      let validate_new = true;

      if (this.containerModal.containerTypeId == "") {
        $("#containerTypeId").focus();
        this.containerTypeIdError = "Select Container Type";
        validate_new = false;
      }
      if (this.containerModal.noOfContainer == "") {
        $("#noOfContainer").focus();
        this.noOfContainerError = "Enter No of Container";
        validate_new = false;
      }

      if (validate_new != true) {
        this.validate = false;
      } else {
        this.validate = true;
      }
    },
    getData() {
      let array = [];
      this.doLoading();
      let vehicle_drive = {
        itemCode: "itemCode",
        allModuleId:
          this.$sessionsStorage.get("editallModuleId") != "" ||
          this.$sessionsStorage.get("editallModuleId") != undefined
            ? this.$sessionsStorage.get("editallModuleId")
            : ""
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Enquiry/fetchToAllModulesForm.php`,
        data: JSON.stringify(vehicle_drive),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId")
        }
      };

      axios(options)
        .then(result => {
          const { statusText, status, data } = result;
          if ( status == 200 && data) {
            if (data.CommodityData.length > 0) {
              this.getCommodityData = data.CommodityData;
            } else {
              this.getCommodityData = [];
            }

            if (data.factoryDetail.length > 0) {
              // this.factoryDetail = data.factoryDetail;
              this.tempfactoryDetail = data.factoryDetail;
            }
            console.log(this.tempfactoryDetail);
            if (data.clientdetail.length > 0) {
              this.getCLientData = data.clientdetail;
            } else {
              this.getCLientData = [];
            }

            this.getAlllocationListData = data.LocationDetailsFinal;
            this.getAlllocationHandover = data.LocationDetailsFinal;

            this.getPortDischargeList = data.LocationDetailsSEAPORT;
            this.PortLoadList = data.LocationDetailsSEAPORT;

            this.finalAllPlaceData = data.LocationDetailsFinal;

            if (data.slineDetails.length > 0) {
              this.getShippingLineData = data.slineDetails;
            } else {
              this.getShippingLineData = [];
            }

            if (data.containerMaster.length > 0) {
              this.getContainerTypeData = data.containerMaster;
            } else {
              this.getContainerTypeData = [];
            }

            if (data.editAssignmentData.length > 0) {
              Object.keys(data.editAssignmentData[0]).map(x => {
                if (x == "jobType") {
                  array = data.editAssignmentData[0][x].split(",");
                  this.newJobType = data.editAssignmentData[0][x].split(",");
                } else {
                  this.ffExoprtDetail[x] = data.editAssignmentData[0][x] || "";
                }
              });

              this.ffExoprtDetail["jobType"] = [];

              this.showSegmentArray.map((x, index) => {
                let i = array.indexOf(x.value);

                i >= 0
                  ? (this.ffExoprtDetail.jobType[index] = true)
                  : (this.ffExoprtDetail.jobType[index] = false);
              });
              if (this.ffExoprtDetail["portType"] == "Icd") {
                this.IcdPOrtList = data.LocationDetailsFinal;
              } else {
                this.IcdPOrtList = data.LocationDetailsSEAPORT;
              }
            } else {
              this.IcdPOrtList = data.LocationDetailsSEAPORT;
            }

            this.doLoadingClose();
            this.JqueryFun();
          }
        })
        .catch(error => {});
    },

    

    addNew() {
      this.$router.push({
        path: "/client/addClient"
      });
    },

    previousFFView() {
      this.$router.push({
        path: "/viewAllModuleDetails/viewAllModuleDetails"
      });
    },

    getServicesData() {
      this.showSegmentArray = [
        {
          value: "FF",
          show: "Freight Forwarding(FF)",
          flex: "20"
        },
        {
          value: "CC",
          show: "Customs Clearance(CC)",
          flex: "20"
        },
        {
          value: "TPT",
          show: "Transportation(TPT)",
          flex: "20"
        }

        // {
        //   value: "All",
        //   show: "All",
        //   flex: "15"
        // }
      ];
    }
  }
};
</script>
<style>
.md-direction-bottom-right {
  width: 18% !important;
}

.center {
  text-align: center;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// allModuleForm.vue?2ba8e170